// extracted by mini-css-extract-plugin
export default {"container":"container--gYGIC1eKa0cCByb6kRy2","component-error":"component-error--w5O5Znx11J28RwZ6oNmI"};